import React, { useState, useEffect } from 'react';

const Calculator = () => {
  const [value1, setValue1] = useState('$48,108');
  const [value2, setValue2] = useState('9');
  const [total, setTotal] = useState(null);

	useEffect(() => {
    // Calculate total when the component mounts with default values
    const num1 = parseFloat(value1.replace(/[\$,]/g, '')) || 0;
    const num2 = parseFloat(value2) || 0;
    setTotal(num1 * num2);
  }, [ value1, value2 ]); // Empty dependency array ensures useEffect runs only once on mount

  const formatWithCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handleInputChange = (e, setValue) => {
    let inputValue = e.target.value;

    // Remove commas before parsing
    const numericValue = parseFloat(inputValue.replace(/[\$,]/g, ''));

    setValue(formatWithCommas(numericValue));

    // Calculate total whenever either input changes
    const num1 = parseFloat(numericValue) || 0;
    const num2 = parseFloat(value2) || 0;
    setTotal(num1 * num2);
  };

  const handleWheel = (e) => {
    // Prevent scrolling with the mouse wheel
    e.preventDefault();
  };

  return (
    <div>		
			<form className="calc-form pad-m-b">
				<div className="mb-3">
					<label className="form-label open-sans">Cost per incidence
						<input type="text" className="form-control compatil-bold color-1 no-spinners" value={value1} onChange={(e) => handleInputChange(e, setValue1)} onWheel={handleWheel} readOnly />
					</label>
				</div>
				<div className="mb-3">
					<label className="form-label open-sans">Number of CLABSI cases
						<input type="number" className="form-control compatil-bold color-1" value={value2} onChange={(e) => handleInputChange(e, setValue2)} />
					</label>
				</div>
				<div className="mb-3">
					<label className="form-label open-sans">Total economic impact
						<div className="form-control compatil-bold mb-3 color-2 total">
              {total !== null ? `$${formatWithCommas(total)}` : '$0'}
            </div>
					</label>
					<div className="form-text open-sans">Number of CLABSIs times the average cost to a<br></br> healthcare system of a single CLABSI incident.<sup>1,2</sup></div>
				</div>
			</form>
    </div>
  );
};

export default Calculator;
